export default "__VITE_ASSET__db802d69__"